<template>
  <div class="row">
    <div class="col-sm-5">
      <div class="card">
        <div class="card-header">
          <h5 class="card-title">Decorations</h5>
        </div>
        <top-table
          :isSelectable="true"
          ref="tableSupplierDecoration"
          :columns="['decorationName', 'setups', 'runs', 'mapping']"
          :sortable="['decorationName']"
          :order-by="{ column: 'decorationName', ascending: 1 }"
          :headings="{ decorationId: 'ID' }"
          :request-function="onBeforeReq"
          :url="`/suppliers/${supplier._id}/decorations`"
          :options="{
            perPage: 25,
            perPageValues: [100],
            orderBy: { column: 'decorationName' }
          }"
          :tab-filters="[
            {
              label: 'Only not mapped',
              val: 'notMapped',
              criteria: [
                { value: 'Yes', name: 'Yes' },
                { value: 'No', name: 'No' }
              ]
            }
          ]"
          :overlap="false"
          class="p-3"
        >
          <span slot="customAfterFilter" slot-scope="props">
            <div class="mt-4 ml-2" :key="props.selected.length || -1">
              <FormModal
                :noSave="true"
                :disabled="!props.selected.length"
                :item="{
                  charges: [],
                  decorationNames: props.selected,
                  label: null
                }"
                :supplier="supplier"
                @change="(e) => onSave(props.row, e)"
              />
            </div>
          </span>
          <template v-slot:setups="props">
            <div v-if="props.row.setups.length" class="d-flex align-items-center">
              <span
                class="badge badge-primary ml-2 p-2"
                v-if="props.row.setups.length > 0"
                v-b-tooltip.hover
                :title="props.row.setups.join(', ')"
              >
                {{ props.row.setups.length }}
              </span>
            </div>
            <div v-else>-</div>
          </template>
          <template v-slot:runs="props">
            <div v-if="props.row.runs.length" class="d-flex align-items-center">
              <span
                class="badge badge-primary ml-2 p-2"
                v-if="props.row.runs.length > 0"
                v-b-tooltip.hover
                :title="props.row.runs.join(', ')"
              >
                {{ props.row.runs.length }}
              </span>
            </div>
            <div v-else>-</div>
          </template>
          <template v-slot:mapping="props">
            <div class="d-flex align-items-center" :key="props.row._id">
              <FormModal
                :noSave="true"
                :item="{
                  charges: [],
                  decorationNames: [props.row],
                  label: null
                }"
                :supplier="supplier"
                @change="(e) => onSave(props.row, e)"
              />
              <i v-if="props.row.checked" class="far fa-check-circle text-success ml-2"></i>
            </div>
          </template>
        </top-table>
      </div>
    </div>

    <div class="col-sm-7">
      <div class="card">
        <div class="card-header d-flex justify-content-between">
          <div>
            <h5 class="card-title">Mapped</h5>
          </div>
          <div>
            <ProductsFeeds
              :params="{ suppliers: [supplier._id] }"
              :is-service="true"
              :label="`Suplier products locations`"
              :url="`/products/check-locations`"
              :labelProgress="`Products`"
              :help="`Check all supplier products selected locations`"
            />
          </div>
        </div>
        <top-table
          ref="tableDecoration"
          :columns="['decorationNames', 'setups', 'run', 'label', 'actions']"
          :sortable="['decorationNames', 'label']"
          :order-by="{ column: 'decorationNames', ascending: 1 }"
          :headings="{ decorationId: 'ID', label: 'Price Includes' }"
          :request-function="onBeforeReq"
          :onLoadData="onLoadData"
          :url="`/suppliers/${supplier._id}/dist-decorations`"
          :tabFilters="tabFilters"
          class="p-3"
        >
          <div class="mt-2 no-gutters d-flex flex-wrap align-items-center w-100" slot="tabsFilter" slot-scope="props">
            <FormModal
              :item="{
                charges: [],
                decorationNames: [],
                decorationUnitsIncluded: [],
                decorationUnitsIncludedUom: [],
                decorationUnitsMax: [],
                label: null
              }"
              :supplier="supplier"
              @change="props.refresh"
            />
          </div>
          <template v-slot:decorationNames="props">
            <div class="d-flex align-items-center">
              <ProductsAll
                :query="`status=active&supplierId=${supplier._id}&decorationNames=${props.row.decorationNames}`"
              />
              <FormModal
                isEdit
                :item="props.row"
                :key="props.row.updatedAt"
                :supplier="supplier"
                @change="props.refresh"
              />
            </div>
          </template>
          <template v-slot:setups="props">
            <div v-if="props.row.charges.length" class="d-flex align-items-center">
              <span
                class="badge badge-primary ml-2 p-2"
                v-if="props.row.charges.filter((e) => e.type === 'setup').length > 0"
                v-b-tooltip.hover
                :title="
                  props.row.charges
                    .filter((e) => e.type === 'setup')
                    .map((e) => e.name)
                    .join(', ')
                "
              >
                {{ props.row.charges.filter((e) => e.type === 'setup').length }}
              </span>
            </div>
            <div v-else>-</div>
          </template>
          <template v-slot:run="props">
            <div v-if="props.row.charges.length" class="d-flex align-items-center">
              <span
                class="badge badge-primary ml-2 p-2"
                v-if="props.row.charges.filter((e) => e.type === 'run').length > 0"
                v-b-tooltip.hover
                :title="
                  props.row.charges
                    .filter((e) => e.type === 'run')
                    .map((e) => e.name)
                    .join(', ')
                "
              >
                {{ props.row.charges.filter((e) => e.type === 'run').length }}
              </span>
            </div>
            <div v-else>-</div>
          </template>
          <template v-slot:actions="props">
            <div class="d-flex align-items-center">
              <div class="ml-1">
                <delete-button
                  :remove="() => remove(props)"
                  :title="props.row.decorationNames[0]"
                  btnClass=" btn-link"
                />
              </div>
            </div>
          </template>
        </top-table>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    supplier: {
      type: Object
    }
  },
  components: {
    ProductsAll: () => import('../../../../components/ProductsAll'),
    FormModal: () => import('./FormModal'),
    ProductsFeeds: () => import('../../Products/ProductsFeeds')
  },
  data() {
    return {
      tabFilters: [
        {
          name: 'Price Includes',
          val: 'label',
          criteria: []
        }
      ]
    };
  },
  methods: {
    onSave(item, el) {
      this.$refs.tableDecoration.$refs.table.refresh();
      if (item) item.checked = 1;
      this.$refs.tableSupplierDecoration.$refs.table.data.forEach((e) => {
        if (el.decorationNames.map((e) => e.decorationName || e).includes(e.decorationName)) {
          e.checked = 1;
        }
      });
    },
    onLoadData({ totalLabels }) {
      if (!this.tabFilters[0].criteria.length)
        this.tabFilters[0].criteria.push(...totalLabels.map((e) => ({ val: e._id, name: `${e._id}(${e.total})` })));
    },
    async remove(props) {
      this.$refs.tableSupplierDecoration.$refs.table.data.forEach((e) => {
        if (
          // (e.decoration_id || e.decorationId).toString() === props.row.decorationId &&
          props.row.decorationNames.includes(e.decorationName)
        ) {
          e.checked = 0;
        }
      });
      await this.$http.delete(`/suppliers/${this.supplier._id}/dist-decorations/${props.row._id}`);
      props.refresh();
    },
    onBeforeReq(p) {
      p.fields = ['decorationName'];
    }
  }
};
</script>
